import dayjs from 'dayjs';

export const formatDate = (date: any, format: string = 'MMM DD, YYYY') => {
  if (!date) {
    return ''
  }
  return dayjs(date).format(format);
}